module.exports = __webpack_public_path__ + "static/semanticui.18b16ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/semanticui.png
// module id = 857
// module chunks = 73261030922168